module.exports = __webpack_public_path__ + "img/play.f43079f2.svg";